import request from 'client/utils/request'
import {
  CalculatePriceRequest,
  CalculatePriceResponse,
} from 'src/shared/types/pricing-types'

export const calculatePrice = (
  data: CalculatePriceRequest[],
  abortSignal?: AbortSignal,
) =>
  request.post<CalculatePriceResponse[]>(
    `${process.env.SYSTEME_IO_HOST}/api/payment/calculate-price/v2`,
    data,
    {
      signal: abortSignal,
    },
  )
